/* @flow */
import React from 'react';
import PropTypes from 'prop-types';

import { Button, buttonTypes, buttonSizes } from 'moods-react/Button';
import { IconUiCloseXbold } from 'moods-react/Icons';
import './CloseButton.scss';

/**
 * Common Close button
 */
export type CloseButtonProps = {
  onClick?: () => void,
  alignRight?: boolean,
};

const CloseButtonComponent = (props: CloseButtonProps) => (
  <div className={`close-button-component ${props.alignRight ? 'close-button-component--right' : ''}`}>
    <Button
      data-close-btn
      isDisc
      onClick={props.onClick}
      icon={IconUiCloseXbold}
      type={buttonTypes.STANDALONE_WHITE}
      size={buttonSizes.LARGE}
    />
  </div>
);

CloseButtonComponent.propTypes = {
  onClick: PropTypes.func,
  alignRight: PropTypes.bool,
};

CloseButtonComponent.defaultProps = {
  onClick() {},
  alignRight: false,
};

CloseButtonComponent.displayName = 'CloseButton';

export default CloseButtonComponent;
